import React from 'react';
import PropTypes from 'prop-types';
import HeaderRow from './SkillHeaderRow/SkillHeaderRow';
import ClassSummary from './ClassSummary/ClassSummary';
import PerformanceRow from './PerformanceRow/PerformanceRow';
import './FeatureReport.scss';
import { generateReactKey } from '../../../utils/shared/commonUtils';
import { CLASS_SUM_REP_TABLE } from '../../../constants/reading/DemoModeConstants';
import { SECTION_IDS, TITLE } from '../../../constants/shared/CommonConstants';

const FeatureReport = ({
    totalStudentCount,
    performanceTables,
    infoSummary,
    toyPeriods,
    summerPeriodLabel,
}) => (
    <div
        className="class-performance container"
        data-tour-step={CLASS_SUM_REP_TABLE}
        id={SECTION_IDS.FEATURE_REPORT_TABLE}
    >
        <ClassSummary infoSummary={infoSummary} totalStudentCount={totalStudentCount} />
        <div className="d-flex feature-report-tables">
            {performanceTables.map(
                ({ key, levelTypeTitle, levelTitles, skills, performanceRows }) => (
                    <div key={generateReactKey(key)} className="performance-table">
                        <HeaderRow
                            skills={skills}
                            classNameCell="perfomance-cell"
                            toyPeriods={toyPeriods}
                            summerPeriodLabel={summerPeriodLabel}
                        />
                        {Object.keys(performanceRows).map(level => (
                            <PerformanceRow
                                key={generateReactKey(level)}
                                level={level}
                                levelTypeTitle={levelTypeTitle}
                                levelTitle={levelTitles[level]}
                                performance={performanceRows[level]}
                            />
                        ))}
                    </div>
                ),
            )}
        </div>
    </div>
);

FeatureReport.defaultProps = {
    performanceTables: [],
    totalStudentCount: 0,
    infoSummary: {},
    toyPeriods: [],
    summerPeriodLabel: TITLE.SUMMER_TITLE,
};

FeatureReport.propTypes = {
    performanceTables: PropTypes.array,
    totalStudentCount: PropTypes.number,
    infoSummary: PropTypes.object,
    toyPeriods: PropTypes.array,
    summerPeriodLabel: PropTypes.string,
};

export default FeatureReport;
